import { useEffect } from 'react'
import { ModalButtons, ModalContent, ModalOverlay, StyledListaDeNumeros, TableContainer } from './style'
import { IoMdClose } from 'react-icons/io';
import { RegistrationButton } from '../../../../../../../styles/registrationButton';
import { Contact, Customer } from '../../../../../../../interfaces/Customers.interface';
import { CustomState } from '../../../../../../../Hooks/State.hook';
import api from '../../../../../../../services/api';
import { TableItem } from './TableItem';
import Input from '../../../../../../../components/Input';
import { defaultInput100, defaultInput50 } from '../../../../../../../components-variants/defaultInputs';
import { FaSearch } from 'react-icons/fa';
import { toast } from 'react-toastify';

interface TableProps {
    customer: Customer;
    closeFunction: () => void;
};

interface ContactFormState {
    NOME: string;
    NUMERO: string;
    CODIGO_CLIENTE: number;
}

interface FilterState {
    NOME: string;
    NUMERO: string;
}

const ListaDeTelefone = ({ customer, closeFunction }: TableProps) => {
    const contacts = CustomState<Array<Contact>>([]);
    const formState = CustomState<ContactFormState>({ NOME: "", NUMERO: "", CODIGO_CLIENTE: customer.CODIGO });
    const filtersState = CustomState<FilterState>({ NOME: "", NUMERO: "" });
    const showConfirmModal = CustomState(false);
    const modalMessage = CustomState("");
    const pendingContact = CustomState<ContactFormState | null>(null);

    useEffect(() => {
        loadContacts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const filteredContacts = contacts.value.filter((v) => {
        return (
            (filtersState.value.NOME
                ? v.NOME.toUpperCase().includes(filtersState.value.NOME.toUpperCase())
                : true) &&
            (filtersState.value.NUMERO
                ? v.NUMERO.includes(filtersState.value.NUMERO.replace(/\D/g, ""))
                : true)
        );
    });

    function loadContacts() {
        api.get(`/contacts/findByCustomer/${customer.CODIGO}`)
            .then((res) => {
                console.log(res.data);
                contacts.set(res.data);
            });
    };

    const onSubmitFunction = async () => {
        const numero = formState.value.NUMERO.replace(/\D/g, "");
        if (!numero) {
            toast.error("Número inválido");
            return;
        }

        try {
            const res = await api.get(`/contacts/findByContact/${numero}`);
            const contatosEncontrados: Contact = res.data;
            if (contatosEncontrados) {
                const resp = await api.get(`customers/custom/filter?page=1&perPage=20&field=CODIGO&value=${contatosEncontrados.CODIGO_CLIENTE}`);
                const RAZAO = resp.data.data[0].RAZAO
                modalMessage.set(`O número já está cadastrado para o cliente "${RAZAO || contatosEncontrados.CODIGO_CLIENTE}". Deseja continuar mesmo assim?`);
                pendingContact.set({ ...formState.value, NUMERO: numero });
                showConfirmModal.set(true);
                return;
            }

            await salvarContato({ ...formState.value, NUMERO: numero });

        } catch (error) {
            console.error("Erro ao salvar número:", error);
            toast.error("Falha ao salvar contato do cliente...");
            toast.error("Número de telefone inválido ou já existente.");
        }
    };
    const salvarContato = async (contato: ContactFormState) => {
        try {
            await api.post(`/contacts/`, contato);
            toast.success("Contato salvo com sucesso!");
            loadContacts();
            closeFunction();
        } catch (error) {
            console.error("Erro ao salvar:", error);
            toast.error("Erro ao salvar o contato.");
        }
    };

    return (
        <TableContainer>
            {showConfirmModal.value && (
            <ModalOverlay>
                <ModalContent>
                    <p>{modalMessage.value}</p>
                    <ModalButtons>
                        <button
                            className="cancelar"
                            onClick={() => {
                                showConfirmModal.set(false);
                                toast.info("Operação cancelada.");
                            }}
                        >
                            Cancelar
                        </button>
                        <button
                            className="confirmar"
                            onClick={async () => {
                                if (pendingContact.value) {
                                    await salvarContato(pendingContact.value);
                                    toast.warn("Número salvo mesmo já existindo em outro cliente.");
                                    showConfirmModal.set(false);
                                }
                            }}
                        >
                            Continuar assim mesmo
                        </button>
                    </ModalButtons>
                </ModalContent>
            </ModalOverlay>
        )}
            <header>
                <h2> Contatos de "{customer.RAZAO}" </h2>
                <button className='closeModal' onClick={closeFunction}>
                    <IoMdClose />
                </button>
            </header>
            <StyledListaDeNumeros>
                <header>
                    <div>
                        Ações
                    </div>
                    <div>
                        Código
                    </div>
                    <div>
                        <Input
                            placeholder="Nome"
                            value={filtersState.value.NOME}
                            onChange={(e) => filtersState.set(prev => ({ ...prev, NOME: e.target.value }))}
                            {...defaultInput100}
                            $padding={[0.375, 0.375]}
                            $fontSize={0.75}
                            leftIcon={<FaSearch />}
                        />
                    </div>
                    <div>
                        <Input
                            placeholder="Número"
                            value={filtersState.value.NUMERO}
                            onChange={(e) => filtersState.set(prev => ({ ...prev, NUMERO: e.target.value }))}
                            {...defaultInput100}
                            $padding={[0.375, 0.375]}
                            $fontSize={0.75}
                            leftIcon={<FaSearch />}
                        />
                    </div>
                </header>
                <ul>
                    {filteredContacts.map((contact) => <TableItem
                        contact={contact}
                        key={contact.NUMERO}
                        closeFunction={loadContacts}
                    />)}
                </ul>
            </StyledListaDeNumeros>
            <h3> Novo contato </h3>
            <div className="inputs">
                <Input
                    placeholder="Nome do contato"
                    minLength={6}
                    onChange={(e) => formState.set(prev => ({ ...prev, NOME: e.target.value }))}
                    value={formState.value.NOME}
                    required
                    {...defaultInput50}
                    $padding={[0.5, 0.5]}
                />

                <Input
                    placeholder="Número Whatsapp ex: 551198765432"
                    minLength={6}
                    value={formState.value.NUMERO}
                    onChange={(e) => formState.set(prev => ({ ...prev, NUMERO: String(e.target.value.replace(/\D/g, "")) }))}
                    required
                    {...defaultInput50}
                    $padding={[0.5, 0.5]}
                />
            </div>

            <RegistrationButton onClick={onSubmitFunction}>
                Adicionar
            </RegistrationButton>
        </TableContainer>
    );
}

export default ListaDeTelefone;